export default __webpack_public_path__ + "static/388-4167e25a9b1b06f32eb3cebdab5cb3cf.gif";